import { useCallback, useMemo, useState } from 'react'
import { GridApi, useGridApiEventHandler } from '@mui/x-data-grid-pro'

import { useFilteredGridColumns } from './useFilteredGridColumns'
import type { FieldState, GridColumnsSelectorSlotProps } from './typings'

type Params = GridColumnsSelectorSlotProps & {
  apiRef: React.MutableRefObject<GridApi>
}

export function useButtonActions(params: Params) {
  const { apiRef, saveCallback } = params

  const [open, setOpen] = useState(false)
  const onOpen = useCallback(() => setOpen(true), [])
  const onClose = useCallback(() => setOpen(false), [])

  const internalColumns = useFilteredGridColumns(apiRef)

  const columnCount = useMemo(() => {
    const { orderedFields: all, columnVisibilityModel: cvm } = internalColumns
    const total = all.length

    const visible = Object.keys(cvm)
      .map((k) => cvm[k])
      .filter((k) => k).length

    return `${visible}/${total}`
  }, [internalColumns])

  const onDragEnd = useCallback(() => {
    const { orderedFields: all, columnVisibilityModel: cvm } = internalColumns

    const fieldStates = all.map<FieldState>((field) => ({
      field,
      hide: !(cvm[field] === undefined ? true : cvm[field]),
    }))

    saveCallback(fieldStates)
  }, [internalColumns, saveCallback])

  useGridApiEventHandler(apiRef, 'columnHeaderDragEnd', onDragEnd)

  return {
    open,
    onOpen,
    onClose,
    columnCount,
  }
}
